// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file recovery.proto (package org.callisto.recovery.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file recovery.proto.
 */
export const file_recovery: GenFile = /*@__PURE__*/
  fileDesc("Cg5yZWNvdmVyeS5wcm90bxIYb3JnLmNhbGxpc3RvLnJlY292ZXJ5LnYxIhwKC09QUkZSZXF1ZXN0Eg0KBWFscGhhGAEgASgMIhwKDE9QUkZSZXNwb25zZRIMCgRiZXRhGAEgASgMIi4KElNldHVwX1BPUFJGUmVxdWVzdBINCgVhbHBoYRgBIAEoDBIJCgFuGAIgASgMIiMKE1NldHVwX1BPUFJGUmVzcG9uc2USDAoEYmV0YRgBIAEoDCJmChFTZXR1cF9TYXZlUmVxdWVzdBIKCgJpZBgBIAEoDBIKCgJlRRgCIAEoDBIKCgJrRRgDIAEoDBIKCgJlQRgEIAEoDBIKCgJrQRgFIAEoDBIJCgFuGAYgASgMEgoKAnBrGAcgASgMIhQKElNldHVwX1NhdmVSZXNwb25zZSJIChRSZXF1ZXN0X1N0YXJ0UmVxdWVzdBIKCgJpZBgBIAEoDBINCgVrT1RQRRgCIAEoDBIVCg1tYWlsRG9tYWluS2V5GAMgASgJIhcKFVJlcXVlc3RfU3RhcnRSZXNwb25zZSImChVSZWNvdmVyeV9TdGFydFJlcXVlc3QSDQoFdG9rZW4YASABKAkiLQoWUmVjb3ZlcnlfU3RhcnRSZXNwb25zZRITCgt0cmFuc2FjdGlvbhgBIAEoCSJDCh1SZWNvdmVyeV9WYWxpZGF0ZVRva2VuUmVxdWVzdBINCgV0b2tlbhgBIAEoCRITCgt0cmFuc2FjdGlvbhgCIAEoCSJkCh5SZWNvdmVyeV9WYWxpZGF0ZVRva2VuUmVzcG9uc2USEQoJcXVlc3Rpb25zGAEgAygJEgoKAmVBGAIgASgMEgsKA2tBMRgDIAEoDBILCgNrQTIYBCABKAwSCQoBbRgFIAEoDCJKChVSZWNvdmVyeV9QT1BSRlJlcXVlc3QSDQoFdG9rZW4YASABKAkSEwoLdHJhbnNhY3Rpb24YAiABKAkSDQoFYWxwaGEYAyABKAwiJgoWUmVjb3ZlcnlfUE9QUkZSZXNwb25zZRIMCgRiZXRhGAEgASgMIi8KDkRlbGV0ZV9SZXF1ZXN0EgoKAmlkGAEgASgMEhEKCXNpZ25hdHVyZRgCIAEoDCIRCg9EZWxldGVfUmVzcG9uc2UiSAoXRGVsZXRlX0J5X1Byb3h5X1JlcXVlc3QSCgoCaWQYASABKAwSEQoJc2lnbmF0dXJlGAIgASgMEg4KBnVzZXJJZBgDIAEoCSIaChhEZWxldGVfQnlfUHJveHlfUmVzcG9uc2UibgoOVXBkYXRlX1JlcXVlc3QSCgoCaWQYASABKAwSDQoFbmV3SWQYAiABKAwSCgoCZUUYAyABKAwSCgoCa0UYBCABKAwSCgoCZUEYBSABKAwSCgoCa0EYBiABKAwSEQoJc2lnbmF0dXJlGAcgASgMIhEKD1VwZGF0ZV9SZXNwb25zZSJ1ChZVcGRhdGVEaXJlY3RseV9SZXF1ZXN0EgkKAW4YASABKAwSDQoFbmV3SWQYAiABKAwSCgoCZUUYAyABKAwSCgoCa0UYBCABKAwSCgoCZUEYBSABKAwSCgoCa0EYBiABKAwSEQoJc2lnbmF0dXJlGAcgASgMIhkKF1VwZGF0ZURpcmVjdGx5X1Jlc3BvbnNlMuwJCg9SZWNvdmVyeVNlcnZpY2USVwoEb3ByZhIlLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5PUFJGUmVxdWVzdBomLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5PUFJGUmVzcG9uc2UiABJsCgtzZXR1cF9QT1BSRhIsLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5TZXR1cF9QT1BSRlJlcXVlc3QaLS5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuU2V0dXBfUE9QUkZSZXNwb25zZSIAEmkKCnNldHVwX1NhdmUSKy5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuU2V0dXBfU2F2ZVJlcXVlc3QaLC5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuU2V0dXBfU2F2ZVJlc3BvbnNlIgAScgoNcmVxdWVzdF9TdGFydBIuLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5SZXF1ZXN0X1N0YXJ0UmVxdWVzdBovLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5SZXF1ZXN0X1N0YXJ0UmVzcG9uc2UiABJ1Cg5yZWNvdmVyeV9TdGFydBIvLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5SZWNvdmVyeV9TdGFydFJlcXVlc3QaMC5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuUmVjb3ZlcnlfU3RhcnRSZXNwb25zZSIAEo0BChZyZWNvdmVyeV9WYWxpZGF0ZVRva2VuEjcub3JnLmNhbGxpc3RvLnJlY292ZXJ5LnYxLlJlY292ZXJ5X1ZhbGlkYXRlVG9rZW5SZXF1ZXN0Gjgub3JnLmNhbGxpc3RvLnJlY292ZXJ5LnYxLlJlY292ZXJ5X1ZhbGlkYXRlVG9rZW5SZXNwb25zZSIAEnUKDnJlY292ZXJ5X1BPUFJGEi8ub3JnLmNhbGxpc3RvLnJlY292ZXJ5LnYxLlJlY292ZXJ5X1BPUFJGUmVxdWVzdBowLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5SZWNvdmVyeV9QT1BSRlJlc3BvbnNlIgASXwoGZGVsZXRlEigub3JnLmNhbGxpc3RvLnJlY292ZXJ5LnYxLkRlbGV0ZV9SZXF1ZXN0Gikub3JnLmNhbGxpc3RvLnJlY292ZXJ5LnYxLkRlbGV0ZV9SZXNwb25zZSIAEnoKD2RlbGV0ZV9CeV9Qcm94eRIxLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5EZWxldGVfQnlfUHJveHlfUmVxdWVzdBoyLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5EZWxldGVfQnlfUHJveHlfUmVzcG9uc2UiABJfCgZ1cGRhdGUSKC5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuVXBkYXRlX1JlcXVlc3QaKS5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuVXBkYXRlX1Jlc3BvbnNlIgASdwoOdXBkYXRlRGlyZWN0bHkSMC5vcmcuY2FsbGlzdG8ucmVjb3ZlcnkudjEuVXBkYXRlRGlyZWN0bHlfUmVxdWVzdBoxLm9yZy5jYWxsaXN0by5yZWNvdmVyeS52MS5VcGRhdGVEaXJlY3RseV9SZXNwb25zZSIAQhlaF2NhbGxpc3RvdmF1bHQub3JnL3Byb3RvYgZwcm90bzM");

/**
 * @generated from message org.callisto.recovery.v1.OPRFRequest
 */
export type OPRFRequest = Message<"org.callisto.recovery.v1.OPRFRequest"> & {
  /**
   * This is a blinded input provided by the user, which will be raised to
   * the static exponent the server keeps.
   *
   * @generated from field: bytes alpha = 1;
   */
  alpha: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.OPRFRequest.
 * Use `create(OPRFRequestSchema)` to create a new message.
 */
export const OPRFRequestSchema: GenMessage<OPRFRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 0);

/**
 * @generated from message org.callisto.recovery.v1.OPRFResponse
 */
export type OPRFResponse = Message<"org.callisto.recovery.v1.OPRFResponse"> & {
  /**
   * This is the multiplied input. The user will unblind this to retrieve
   * the final output.
   *
   * @generated from field: bytes beta = 1;
   */
  beta: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.OPRFResponse.
 * Use `create(OPRFResponseSchema)` to create a new message.
 */
export const OPRFResponseSchema: GenMessage<OPRFResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 1);

/**
 * @generated from message org.callisto.recovery.v1.Setup_POPRFRequest
 */
export type Setup_POPRFRequest = Message<"org.callisto.recovery.v1.Setup_POPRFRequest"> & {
  /**
   * This is the blinded input provided by the user, which will be raised to
   * an exponent derived from n and the server's OPRF key.
   *
   * @generated from field: bytes alpha = 1;
   */
  alpha: Uint8Array;

  /**
   * This is a unique nonce provided by the user, which will be used to
   * derive the actual exponent for OPRF.
   *
   * @generated from field: bytes n = 2;
   */
  n: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Setup_POPRFRequest.
 * Use `create(Setup_POPRFRequestSchema)` to create a new message.
 */
export const Setup_POPRFRequestSchema: GenMessage<Setup_POPRFRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 2);

/**
 * @generated from message org.callisto.recovery.v1.Setup_POPRFResponse
 */
export type Setup_POPRFResponse = Message<"org.callisto.recovery.v1.Setup_POPRFResponse"> & {
  /**
   * This is the multiplied output. The user will unblind this to retrieve
   * the final output.
   *
   * @generated from field: bytes beta = 1;
   */
  beta: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Setup_POPRFResponse.
 * Use `create(Setup_POPRFResponseSchema)` to create a new message.
 */
export const Setup_POPRFResponseSchema: GenMessage<Setup_POPRFResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 3);

/**
 * @generated from message org.callisto.recovery.v1.Setup_SaveRequest
 */
export type Setup_SaveRequest = Message<"org.callisto.recovery.v1.Setup_SaveRequest"> & {
  /**
   * This is an ID, computed by the user to make fast lookups possible.
   *
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * This is the encrypted contact information.
   *
   * @generated from field: bytes eE = 2;
   */
  eE: Uint8Array;

  /**
   * This is the secret share of the key to the contact information, which
   * must be different for each server this is sent to.
   *
   * @generated from field: bytes kE = 3;
   */
  kE: Uint8Array;

  /**
   * This is the encrypted envelope, which contains the user's keys.
   *
   * @generated from field: bytes eA = 4;
   */
  eA: Uint8Array;

  /**
   * This is the secret share of the key to the envelope, which must be
   * different for each server this is sent to.
   *
   * @generated from field: bytes kA = 5;
   */
  kA: Uint8Array;

  /**
   * This is the user's unique exponent, which is later used for pOPRF.
   *
   * @generated from field: bytes n = 6;
   */
  n: Uint8Array;

  /**
   * This is the public key generated for the user, which will be used
   * to sign a request to delete the recovery info.
   *
   * @generated from field: bytes pk = 7;
   */
  pk: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Setup_SaveRequest.
 * Use `create(Setup_SaveRequestSchema)` to create a new message.
 */
export const Setup_SaveRequestSchema: GenMessage<Setup_SaveRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 4);

/**
 * @generated from message org.callisto.recovery.v1.Setup_SaveResponse
 */
export type Setup_SaveResponse = Message<"org.callisto.recovery.v1.Setup_SaveResponse"> & {
};

/**
 * Describes the message org.callisto.recovery.v1.Setup_SaveResponse.
 * Use `create(Setup_SaveResponseSchema)` to create a new message.
 */
export const Setup_SaveResponseSchema: GenMessage<Setup_SaveResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 5);

/**
 * @generated from message org.callisto.recovery.v1.Request_StartRequest
 */
export type Request_StartRequest = Message<"org.callisto.recovery.v1.Request_StartRequest"> & {
  /**
   * This is the ID computed by the user from their recovery email and phone.
   *
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * This is the one-time-pad secret share computed from their recovery email
   * and phone, which is provided to the server so that it can decrypt the
   * contact info.
   *
   * @generated from field: bytes kOTPE = 2;
   */
  kOTPE: Uint8Array;

  /**
   * This is the environment variable that will be used to lookup what canonical
   * domain to use for the tokenized link in the email.
   *
   * @generated from field: string mailDomainKey = 3;
   */
  mailDomainKey: string;
};

/**
 * Describes the message org.callisto.recovery.v1.Request_StartRequest.
 * Use `create(Request_StartRequestSchema)` to create a new message.
 */
export const Request_StartRequestSchema: GenMessage<Request_StartRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 6);

/**
 * @generated from message org.callisto.recovery.v1.Request_StartResponse
 */
export type Request_StartResponse = Message<"org.callisto.recovery.v1.Request_StartResponse"> & {
};

/**
 * Describes the message org.callisto.recovery.v1.Request_StartResponse.
 * Use `create(Request_StartResponseSchema)` to create a new message.
 */
export const Request_StartResponseSchema: GenMessage<Request_StartResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 7);

/**
 * @generated from message org.callisto.recovery.v1.Recovery_StartRequest
 */
export type Recovery_StartRequest = Message<"org.callisto.recovery.v1.Recovery_StartRequest"> & {
  /**
   * This is the token from the user's email.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message org.callisto.recovery.v1.Recovery_StartRequest.
 * Use `create(Recovery_StartRequestSchema)` to create a new message.
 */
export const Recovery_StartRequestSchema: GenMessage<Recovery_StartRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 8);

/**
 * @generated from message org.callisto.recovery.v1.Recovery_StartResponse
 */
export type Recovery_StartResponse = Message<"org.callisto.recovery.v1.Recovery_StartResponse"> & {
  /**
   * This is a transaction ID, indicating that the token is valid and that
   * further operations on it can commence.
   *
   * @generated from field: string transaction = 1;
   */
  transaction: string;
};

/**
 * Describes the message org.callisto.recovery.v1.Recovery_StartResponse.
 * Use `create(Recovery_StartResponseSchema)` to create a new message.
 */
export const Recovery_StartResponseSchema: GenMessage<Recovery_StartResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 9);

/**
 * @generated from message org.callisto.recovery.v1.Recovery_ValidateTokenRequest
 */
export type Recovery_ValidateTokenRequest = Message<"org.callisto.recovery.v1.Recovery_ValidateTokenRequest"> & {
  /**
   * This is the token from the user's email.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * This is the transaction ID provided by recovery_Start, which is sent to
   * the other server to assist in validating that both have received the
   * correct token.
   *
   * @generated from field: string transaction = 2;
   */
  transaction: string;
};

/**
 * Describes the message org.callisto.recovery.v1.Recovery_ValidateTokenRequest.
 * Use `create(Recovery_ValidateTokenRequestSchema)` to create a new message.
 */
export const Recovery_ValidateTokenRequestSchema: GenMessage<Recovery_ValidateTokenRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 10);

/**
 * @generated from message org.callisto.recovery.v1.Recovery_ValidateTokenResponse
 */
export type Recovery_ValidateTokenResponse = Message<"org.callisto.recovery.v1.Recovery_ValidateTokenResponse"> & {
  /**
   * This is the list of security questions originally picked by the user.
   *
   * @generated from field: repeated string questions = 1;
   */
  questions: string[];

  /**
   * This is the encrypted envelope.
   *
   * @generated from field: bytes eA = 2;
   */
  eA: Uint8Array;

  /**
   * These are the secret shares that the server keeps, which when combined
   * with the one-time pad the user will calculate, can reconstruct the key
   * to the envelope.
   *
   * @generated from field: bytes kA1 = 3;
   */
  kA1: Uint8Array;

  /**
   * @generated from field: bytes kA2 = 4;
   */
  kA2: Uint8Array;

  /**
   * This is a one-time pad for the answers to the security questions.
   *
   * @generated from field: bytes m = 5;
   */
  m: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Recovery_ValidateTokenResponse.
 * Use `create(Recovery_ValidateTokenResponseSchema)` to create a new message.
 */
export const Recovery_ValidateTokenResponseSchema: GenMessage<Recovery_ValidateTokenResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 11);

/**
 * @generated from message org.callisto.recovery.v1.Recovery_POPRFRequest
 */
export type Recovery_POPRFRequest = Message<"org.callisto.recovery.v1.Recovery_POPRFRequest"> & {
  /**
   * This is the token from the user's email.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * This is the transaction ID provided by recovery_Start, which validates
   * that the user has already provided a working token to both servers.
   *
   * @generated from field: string transaction = 2;
   */
  transaction: string;

  /**
   * This is a blinded input from the user, which will be raised to an
   * exponent looked up in the local database.
   *
   * @generated from field: bytes alpha = 3;
   */
  alpha: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Recovery_POPRFRequest.
 * Use `create(Recovery_POPRFRequestSchema)` to create a new message.
 */
export const Recovery_POPRFRequestSchema: GenMessage<Recovery_POPRFRequest> = /*@__PURE__*/
  messageDesc(file_recovery, 12);

/**
 * @generated from message org.callisto.recovery.v1.Recovery_POPRFResponse
 */
export type Recovery_POPRFResponse = Message<"org.callisto.recovery.v1.Recovery_POPRFResponse"> & {
  /**
   * This is the multiplied output. The user will unblind this to retrieve
   * the final output.
   *
   * @generated from field: bytes beta = 1;
   */
  beta: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Recovery_POPRFResponse.
 * Use `create(Recovery_POPRFResponseSchema)` to create a new message.
 */
export const Recovery_POPRFResponseSchema: GenMessage<Recovery_POPRFResponse> = /*@__PURE__*/
  messageDesc(file_recovery, 13);

/**
 * Delete ======================================================================
 *
 * @generated from message org.callisto.recovery.v1.Delete_Request
 */
export type Delete_Request = Message<"org.callisto.recovery.v1.Delete_Request"> & {
  /**
   * This is the ID computed by the user from their recovery email and phone.
   *
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * This is a signature to validate that the user owns this id.
   *
   * @generated from field: bytes signature = 2;
   */
  signature: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Delete_Request.
 * Use `create(Delete_RequestSchema)` to create a new message.
 */
export const Delete_RequestSchema: GenMessage<Delete_Request> = /*@__PURE__*/
  messageDesc(file_recovery, 14);

/**
 * @generated from message org.callisto.recovery.v1.Delete_Response
 */
export type Delete_Response = Message<"org.callisto.recovery.v1.Delete_Response"> & {
};

/**
 * Describes the message org.callisto.recovery.v1.Delete_Response.
 * Use `create(Delete_ResponseSchema)` to create a new message.
 */
export const Delete_ResponseSchema: GenMessage<Delete_Response> = /*@__PURE__*/
  messageDesc(file_recovery, 15);

/**
 * @generated from message org.callisto.recovery.v1.Delete_By_Proxy_Request
 */
export type Delete_By_Proxy_Request = Message<"org.callisto.recovery.v1.Delete_By_Proxy_Request"> & {
  /**
   * This is the ID computed by the user from their recovery email and phone.
   *
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * This is a signature to validate that the user owns this id.
   *
   * @generated from field: bytes signature = 2;
   */
  signature: Uint8Array;

  /**
   * This is the user ID for the user making the request
   *
   * @generated from field: string userId = 3;
   */
  userId: string;
};

/**
 * Describes the message org.callisto.recovery.v1.Delete_By_Proxy_Request.
 * Use `create(Delete_By_Proxy_RequestSchema)` to create a new message.
 */
export const Delete_By_Proxy_RequestSchema: GenMessage<Delete_By_Proxy_Request> = /*@__PURE__*/
  messageDesc(file_recovery, 16);

/**
 * @generated from message org.callisto.recovery.v1.Delete_By_Proxy_Response
 */
export type Delete_By_Proxy_Response = Message<"org.callisto.recovery.v1.Delete_By_Proxy_Response"> & {
};

/**
 * Describes the message org.callisto.recovery.v1.Delete_By_Proxy_Response.
 * Use `create(Delete_By_Proxy_ResponseSchema)` to create a new message.
 */
export const Delete_By_Proxy_ResponseSchema: GenMessage<Delete_By_Proxy_Response> = /*@__PURE__*/
  messageDesc(file_recovery, 17);

/**
 * Update ======================================================================
 *
 * @generated from message org.callisto.recovery.v1.Update_Request
 */
export type Update_Request = Message<"org.callisto.recovery.v1.Update_Request"> & {
  /**
   * This is the original ID that the user had in the system, in case their
   * email/phone number changed and we need to update.
   *
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * This is the new ID that the user has computed from their (potentially)
   * new email/phone number. This might be the same as the original.
   *
   * @generated from field: bytes newId = 2;
   */
  newId: Uint8Array;

  /**
   * This is the encrypted contact information, which might be new.
   *
   * @generated from field: bytes eE = 3;
   */
  eE: Uint8Array;

  /**
   * This is the secret share of the key to the contact information, which
   * must be different for each server this is sent to.
   *
   * @generated from field: bytes kE = 4;
   */
  kE: Uint8Array;

  /**
   * This is the encrypted envelope, which contains the user's keys.
   *
   * @generated from field: bytes eA = 5;
   */
  eA: Uint8Array;

  /**
   * This is the secret share of the key to the envelope, which must be
   * different for each server this is sent to.
   *
   * @generated from field: bytes kA = 6;
   */
  kA: Uint8Array;

  /**
   * This is a signature to validate that the user owns this id.
   *
   * @generated from field: bytes signature = 7;
   */
  signature: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.Update_Request.
 * Use `create(Update_RequestSchema)` to create a new message.
 */
export const Update_RequestSchema: GenMessage<Update_Request> = /*@__PURE__*/
  messageDesc(file_recovery, 18);

/**
 * @generated from message org.callisto.recovery.v1.Update_Response
 */
export type Update_Response = Message<"org.callisto.recovery.v1.Update_Response"> & {
};

/**
 * Describes the message org.callisto.recovery.v1.Update_Response.
 * Use `create(Update_ResponseSchema)` to create a new message.
 */
export const Update_ResponseSchema: GenMessage<Update_Response> = /*@__PURE__*/
  messageDesc(file_recovery, 19);

/**
 * @generated from message org.callisto.recovery.v1.UpdateDirectly_Request
 */
export type UpdateDirectly_Request = Message<"org.callisto.recovery.v1.UpdateDirectly_Request"> & {
  /**
   * This is the `n` marker from the user, which should be unique to them.
   *
   * @generated from field: bytes n = 1;
   */
  n: Uint8Array;

  /**
   * This is the new ID that the user has computed from their (potentially)
   * new email/phone number. This might be the same as the original.
   *
   * @generated from field: bytes newId = 2;
   */
  newId: Uint8Array;

  /**
   * This is the encrypted contact information, which might be new.
   *
   * @generated from field: bytes eE = 3;
   */
  eE: Uint8Array;

  /**
   * This is the secret share of the key to the contact information, which
   * must be different for each server this is sent to.
   *
   * @generated from field: bytes kE = 4;
   */
  kE: Uint8Array;

  /**
   * This is the encrypted envelope, which contains the user's keys.
   *
   * @generated from field: bytes eA = 5;
   */
  eA: Uint8Array;

  /**
   * This is the secret share of the key to the envelope, which must be
   * different for each server this is sent to.
   *
   * @generated from field: bytes kA = 6;
   */
  kA: Uint8Array;

  /**
   * This is a signature to validate that the user owns this id.
   *
   * @generated from field: bytes signature = 7;
   */
  signature: Uint8Array;
};

/**
 * Describes the message org.callisto.recovery.v1.UpdateDirectly_Request.
 * Use `create(UpdateDirectly_RequestSchema)` to create a new message.
 */
export const UpdateDirectly_RequestSchema: GenMessage<UpdateDirectly_Request> = /*@__PURE__*/
  messageDesc(file_recovery, 20);

/**
 * @generated from message org.callisto.recovery.v1.UpdateDirectly_Response
 */
export type UpdateDirectly_Response = Message<"org.callisto.recovery.v1.UpdateDirectly_Response"> & {
};

/**
 * Describes the message org.callisto.recovery.v1.UpdateDirectly_Response.
 * Use `create(UpdateDirectly_ResponseSchema)` to create a new message.
 */
export const UpdateDirectly_ResponseSchema: GenMessage<UpdateDirectly_Response> = /*@__PURE__*/
  messageDesc(file_recovery, 21);

/**
 * This gRPC service is accessible to outside callers, and implements the
 * client-visible parts of the recovery process.
 *
 * Common ==================================================================
 *
 * @generated from service org.callisto.recovery.v1.RecoveryService
 */
export const RecoveryService: GenService<{
  /**
   * oprf implements an OPRF endpoint with a static exponent.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.oprf
   */
  oprf: {
    methodKind: "unary";
    input: typeof OPRFRequestSchema;
    output: typeof OPRFResponseSchema;
  },
  /**
   * setup_POPRF executes an OPRF using an exponent that is provided by the
   * user at setup time, which should be stored later.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.setup_POPRF
   */
  setup_POPRF: {
    methodKind: "unary";
    input: typeof Setup_POPRFRequestSchema;
    output: typeof Setup_POPRFResponseSchema;
  },
  /**
   * setup_Save saves the parameters computed by the user, which are needed
   * later to complete the recovery process.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.setup_Save
   */
  setup_Save: {
    methodKind: "unary";
    input: typeof Setup_SaveRequestSchema;
    output: typeof Setup_SaveResponseSchema;
  },
  /**
   * request_Start decrypts the contact info for the user and potentially
   * sends an email with a token, used in the final steps of the recovery
   * process.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.request_Start
   */
  request_Start: {
    methodKind: "unary";
    input: typeof Request_StartRequestSchema;
    output: typeof Request_StartResponseSchema;
  },
  /**
   * recovery_Start takes a token and starts a "transaction", which is used
   * to ensure that both servers have received and validated the user's input.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.recovery_Start
   */
  recovery_Start: {
    methodKind: "unary";
    input: typeof Recovery_StartRequestSchema;
    output: typeof Recovery_StartResponseSchema;
  },
  /**
   * recovery_ValidateToken is intended to be called from a separate server
   * than recovery_Start was, and checks that the user has provided the same,
   * valid token to each server. Once it has, it returns the necessary
   * parameters for them to complete recovery and decrypt their envelope.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.recovery_ValidateToken
   */
  recovery_ValidateToken: {
    methodKind: "unary";
    input: typeof Recovery_ValidateTokenRequestSchema;
    output: typeof Recovery_ValidateTokenResponseSchema;
  },
  /**
   * recovery_POPRF implements an OPRF using an exponent that is looked up
   * in the local database.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.recovery_POPRF
   */
  recovery_POPRF: {
    methodKind: "unary";
    input: typeof Recovery_POPRFRequestSchema;
    output: typeof Recovery_POPRFResponseSchema;
  },
  /**
   * delete removes recovery information from the database.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.delete
   */
  delete: {
    methodKind: "unary";
    input: typeof Delete_RequestSchema;
    output: typeof Delete_ResponseSchema;
  },
  /**
   * delete_By_Proxy removes recovery information from the database when requested by a DLOC or Admin
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.delete_By_Proxy
   */
  delete_By_Proxy: {
    methodKind: "unary";
    input: typeof Delete_By_Proxy_RequestSchema;
    output: typeof Delete_By_Proxy_ResponseSchema;
  },
  /**
   * update updates the survivor's recovery contact information.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.update
   */
  update: {
    methodKind: "unary";
    input: typeof Update_RequestSchema;
    output: typeof Update_ResponseSchema;
  },
  /**
   * updateDirectly updates the survivor's recovery contact information, similar to `update`, but does a more direct
   * lookup to avoid potential recomputation errors.
   *
   * @generated from rpc org.callisto.recovery.v1.RecoveryService.updateDirectly
   */
  updateDirectly: {
    methodKind: "unary";
    input: typeof UpdateDirectly_RequestSchema;
    output: typeof UpdateDirectly_ResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_recovery, 0);

